import { NewLeaversModalContext } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Modals/NewLeaversModal/NewLeaversModal';
import { ConfirmationModalV3 } from '@dealstack/frontend/shared/components/ConfirmationModal/ConfirmationModalV3';
import {
	TEST_ELEMENT_IDS,
	UIElementIdentifier,
} from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier';
import {
	useTranslationDefault,
	useTranslationMipManage,
} from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Button, Flex } from '@mantine/core';
import { memo, useContext } from 'react';
import { IAlertProps } from '@dealstack/frontend/shared/components/Alert/Alert.types';

const NewLeaversSummary = () => {
	const tMipManage = useTranslationMipManage();
	const tDefault = useTranslationDefault();
	const newLeaversModalController = useContext(NewLeaversModalContext);

	const state: IAlertProps['state'] = newLeaversModalController.isMIP1200CaseValid
		? 'success'
		: 'dangerV3';

	const title = newLeaversModalController.isMIP1200CaseValid
		? tMipManage('confirmation_modal.leaver.title')
		: tDefault(`error_codes.11010913`);

	const description = newLeaversModalController.isMIP1200CaseValid
		? tMipManage('confirmation_modal.leaver.description')
		: '';

	return (
		<ConfirmationModalV3
			title={title}
			description={description}
			state={state}
			children={
				<Flex gap="xs">
					<Button
						size="md"
						variant="secondary"
						onClick={() => {
							newLeaversModalController?.onPreviousStepClicked();
						}}
						disabled={newLeaversModalController.isCompleting}
					>
						{tMipManage('confirmation_modal.back')}
					</Button>
					<UIElementIdentifier
						identifier={TEST_ELEMENT_IDS.NEW_LEAVERS_COMPLETE_SETUP_BUTTON}
					>
						<Button
							onClick={newLeaversModalController?.onComplete}
							variant="ghost"
							disabled={
								newLeaversModalController.isCompleting ||
								!newLeaversModalController.isMIP1200CaseValid
							}
						>
							{tMipManage('confirmation_modal.complete_setup')}
						</Button>
					</UIElementIdentifier>
				</Flex>
			}
		/>
	);
};
const _NewLeaversSummaryExport = memo(NewLeaversSummary);

export { _NewLeaversSummaryExport as NewLeaversSummary };
